<template>
  <svg
    :class="[prefixCls, $attrs.class, spin && 'svg-icon-spin']"
    :style="iconStyle"
    aria-hidden="true"
  >
    <use :xlink:href="symbolId" />
  </svg>
</template>
<script lang="ts" setup>
  import { computed } from 'vue';
  import type { CSSProperties } from 'vue';
  import { useDesign } from '@mts/hooks/web/useDesign';
  import { adaptiveSize } from '@mts/utils';

  defineOptions({ name: 'SvgIcon' });

  const props = defineProps({
    name: {
      type: String,
      required: true,
    },
    size: {
      type: [Number, String],
      default: 16,
    },
    spin: {
      type: Boolean,
      default: false,
    },
  });

  const { prefixCls } = useDesign('svg-icon');
  const symbolId = computed(() => `#${props.name}`);

  const iconStyle = computed((): CSSProperties => {
    const sizeValue = typeof props.size === 'string' ? parseFloat(props.size) : props.size;
    const size = adaptiveSize(sizeValue) + 'px';

    return { width: size, height: size };
  });
</script>
<style lang="less">
  @prefix-cls: ~'@{namespace}-svg-icon';

  .@{prefix-cls} {
    display: inline-block;
    overflow: hidden;
    fill: currentcolor;
    vertical-align: -0.15em;
  }

  .svg-icon-spin {
    animation: loadingCircle 1s infinite linear;
  }
</style>
